module.exports = __webpack_public_path__ + "static/media/sCredits.0804eea3.png";